import { useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import AddWidgetAccordion from 'InpageEditorUI/components/sidebar/add/AddWidgetAccordion';
import PatagoniaSearchTitleWrapper from './PatagoniaSearchTitleWrapper';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { shouldShowSchema } from 'ContentEditorUI/lib/moduleSearchHelpers';
import { getUpgradableModulesWithPQL } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getHasPartnerMatchingAppAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_RESULTS = {
  modules: [],
  count: 0
};
const useFilteredCollections = ({
  categorizedSearchQuery,
  sidebarSearchResultsMap
}) => {
  const upgradableModules = useSelector(getUpgradableModulesWithPQL) || [];
  const filteredCategorizedModuleResults = sidebarSearchResultsMap[PATAGONIA_ADD_PANEL_CATEGORIES.MODULES].results;
  const filteredUpgradableModulesCollection = upgradableModules.filter(upgradableModule => shouldShowSchema(upgradableModule.moduleSchema, categorizedSearchQuery));
  const filteredContainerResults = sidebarSearchResultsMap[PATAGONIA_ADD_PANEL_CATEGORIES.BUILDING_BLOCKS].CONTAINERS;
  const {
    theme = DEFAULT_RESULTS,
    nonTheme = DEFAULT_RESULTS
  } = filteredCategorizedModuleResults;
  return {
    filteredUpgradableModulesCollection,
    filteredThemeResults: theme,
    filteredNonThemeResults: nonTheme,
    filteredContainerResults
  };
};
const SearchResults = ({
  bus,
  categorizedSearchQuery,
  onDragStart,
  onDragEnd,
  sidebarIframeBody,
  sidebarSearchResultsMap,
  disabledModules = {}
}) => {
  const [themeModulesOpen, setThemeModulesOpen] = useState(true);
  const [nonThemeModulesOpen, setNonThemeModulesOpen] = useState(true);
  const hasPartnerMatchingApp = useSelector(getHasPartnerMatchingAppAccess);
  const isEditingGridLayout = useSelector(getIsEditingGridLayouts);
  const {
    filteredUpgradableModulesCollection,
    filteredThemeResults,
    filteredNonThemeResults,
    filteredContainerResults
  } = useFilteredCollections({
    categorizedSearchQuery,
    sidebarSearchResultsMap
  });
  const filteredThemeModules = filteredThemeResults.modules;
  const hasThemeModules = !!filteredThemeModules.length;
  const filteredNonThemeModules = filteredNonThemeResults.modules;
  const hasNonThemeModules = !!filteredNonThemeModules.length;
  const filteredContainers = filteredContainerResults.results;
  const hasContainers = filteredContainerResults.count > 0;
  const hasUpgradableModules = !!filteredUpgradableModulesCollection.length;
  const hasResults = Boolean(hasThemeModules || hasNonThemeModules || hasUpgradableModules || hasContainers);
  const openPartnerMatchingApp = () => {
    bus.postMessage({
      action: 'openPartnerMatchingApp'
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasResults && /*#__PURE__*/_jsxs(_Fragment, {
      children: [isEditingGridLayout && /*#__PURE__*/_jsx(View, {
        paddingInline: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(AddWidgetAccordion, {
          type: "containers",
          sidebarIframeBody: sidebarIframeBody,
          collection: filteredContainers,
          searchQuery: categorizedSearchQuery,
          open: true,
          disabled: !hasContainers,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          disabledModules: disabledModules,
          title: /*#__PURE__*/_jsx(PatagoniaSearchTitleWrapper, {
            title: "Containers",
            isDisabled: !hasContainers,
            resultCount: filteredContainerResults.count
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        paddingInline: "100",
        marginBlockEnd: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(AddWidgetAccordion, {
          type: "themeModules",
          sidebarIframeBody: sidebarIframeBody,
          collection: filteredThemeModules,
          upgradableModules: filteredUpgradableModulesCollection,
          searchQuery: categorizedSearchQuery,
          open: themeModulesOpen && hasThemeModules,
          onOpenChange: () => setThemeModulesOpen(!themeModulesOpen),
          disabled: !hasThemeModules,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          disabledModules: disabledModules,
          title: /*#__PURE__*/_jsx(PatagoniaSearchTitleWrapper, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "patagonia.sidebar.addPanel.searchResultCategories.theme"
            }),
            isDisabled: !hasThemeModules,
            resultCount: filteredThemeResults.count
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        paddingInline: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(AddWidgetAccordion, {
          type: "nonThemeModules",
          sidebarIframeBody: sidebarIframeBody,
          collection: filteredNonThemeModules,
          upgradableModules: filteredUpgradableModulesCollection,
          searchQuery: categorizedSearchQuery,
          open: nonThemeModulesOpen && hasNonThemeModules,
          disabled: !hasNonThemeModules,
          onOpenChange: () => setNonThemeModulesOpen(!nonThemeModulesOpen),
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          disabledModules: disabledModules,
          title: /*#__PURE__*/_jsx(PatagoniaSearchTitleWrapper, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "patagonia.sidebar.addPanel.searchResultCategories.other"
            }),
            isDisabled: !hasNonThemeModules,
            resultCount: filteredNonThemeResults.count
          })
        })
      })]
    }), !hasResults && /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "empty-state-charts",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "addModule.search.failedMessage",
        options: {
          matchingAppLink: hasPartnerMatchingApp ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(View, {
              inlineSize: "70%",
              marginBlockStart: "200",
              marginInline: "auto",
              children: /*#__PURE__*/_jsx(Button, {
                use: "tertiary",
                size: "sm",
                onClick: openPartnerMatchingApp,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "addModule.partnerMatching.linkButton"
                })
              })
            })]
          }) : '',
          searchTerm: categorizedSearchQuery,
          clear: ''
        }
      })
    })]
  });
};
export default SearchResults;